/* eslint-disable eqeqeq */
/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * TenFrameElement.web.js - A square for the ten frame.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './TenFrameElement.web.css';

export default class TenFrameElement extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    // If the object image is defined use that
    if (this.props.object != null || this.props.object != undefined) {
      return (
        <div className="ten_frame_square">
          <img src={this.props.object} />
        </div>
      );
    }

    if (this.props.colour != 'clear') {
      return (
        <div className="ten_frame_square">
          <div className="ten_frame_red_circle" />
        </div>
      );
    }

    return (
      <div className="ten_frame_square">
        <div className="ten_frame_empty_circle" />
      </div>
    );

  }
}

TenFrameElement.propTypes = {
  props: PropTypes.object,
  colour: PropTypes.string,
  object: PropTypes.number,
};
